import { Component, Input, OnInit } from '@angular/core'
import { map, mergeMap } from 'rxjs/operators'
import { ConfigurationRoute, ConfigurationRouteService } from '../../services/configurationRoute.service'
import { ModulePathService } from '../../../../../../framework/module-path-service/module-path.service'
import { Location } from '@angular/common'
import { Observable } from 'rxjs'
import { ConfigurationIdResolver } from '../../resolvers/configurationId.resolver'
import { ConfigurationOptionCategory } from '../../services/configurationCategory.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'mg-configuration-factory-tabs',
    templateUrl: './configuration-factory-tabs.component.html',
    styleUrls: ['./configuration-factory-tabs.component.scss'],
})
export class ConfigurationFactoryTabsComponent implements OnInit {
    @Input()
    public position: 'top' | 'bottom' = 'top'

    public configurationId: string

    accordionRoutes$: Observable<ConfigurationRoute[]>

    constructor(
        private configurationRouteService: ConfigurationRouteService,
        private configurationIdResolver: ConfigurationIdResolver,
        private modulePathService: ModulePathService,
        private location: Location
    ) {}

    ngOnInit(): void {
        // available routes for layout
        this.accordionRoutes$ = this.configurationIdResolver.configurationId$.pipe(
            untilDestroyed(this),
            mergeMap(configurationId => this.configurationRouteService.getConfigurationRoutes(configurationId)),
            map(routes => routes.filter(route => route.isAccordionStep)),
            map(routes => {
                let hasHitCurrentRoute = false
                if (this.position === 'top') {
                    // show all previous and current routes
                    // except if current route is configuration on first index
                    routes = routes.filter(route => {
                        let result = hasHitCurrentRoute === false
                        if (this.isCurrentPath(route.path)) {
                            result = (route.id === 'configurator' && route.index === 0) === false
                            hasHitCurrentRoute = true
                        }
                        return result
                    })
                } else {
                    // show all routes that are coming after this route;
                    routes = routes.filter(route => {
                        const result = hasHitCurrentRoute === true
                        if (this.isCurrentPath(route.path)) {
                            hasHitCurrentRoute = true
                        }
                        return result
                    })
                }

                return routes
            })
        )
    }

    isCurrentPath(path) {
        const location = this.modulePathService.getPathFromModuleRoot(this.location.path().split('?')[0])
        path = this.location.normalize(path)

        return location === path
    }

    checkIfFirstStepCarShopConfigurator(route: ConfigurationRoute): boolean {
        return route.index === 0 && route.category !== ConfigurationOptionCategory.configurator
    }
}
